<template>
  <input class="submit button" :type="type" :value="value" />
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'submit',
    },
    value: [String, Number],
  },
};
</script>
